import { Component } from "react"
import './style.css'

class ErrorView extends Component {
  render(){
    return(
      <div id="frontend-error">
        <div className="wrapper">
          <div className="img-404"/>
          <h1>Houston, we have a problem</h1>
          <h2>Hey it seems like you have lost, there is nothing here! 😟</h2>
          <a href="#/root">Take me home</a>
        </div>
      </div>
    )
  }
}

export default ErrorView
